import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.user.info');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import moment from 'moment';

@Component({
    selector: 'wiz-portal-institute-user-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.user.info/view.scss */
/* src/app/portal.institute.user.info/view.scss: no such file or directory */`],
})
export class PortalInstituteUserInfoComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    @Input() insID: any;
    @Input() mode: any;

    // public trafficPeriod: '1week' | '2weeks' | '1month' | '6months' = '1week';
    public trafficPeriod: 7 | 14 | 30 | 180 = 7;

    public institute: any = {};
    public networks: any = [];
    public selectedPortID: any;
    public port: any = {};

    public traffic: any = null;
    public selectedNetwork: any = { tr: 30 };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관정보 - MY KREONET");
        await this.load();
        // await this.selectNetwork(this.selectedNetwork);
    }

    public async load() {
        const { code, data } = await wiz.call("load", { insID: this.insID });
        if (code != 200) return await this.service.alert.error("Error!");
        this.institute = data.institute;
        this.networks = data.networks;
        this.selectedPortID = this.networks[0].id;
        this.port = this.networks[0];

        await this.selectNetwork(this.networks[0]);

        await this.service.render();
    }

    public async setSeletedPort(id: any) {
        this.selectedPortID = id;
        this.port = this.networks.find(item => item.id === this.selectedPortID);
        await this.selectNetwork(this.port);
        await this.service.render();
    }

    public async selectNetwork(item: any) {
        let tr = this.trafficPeriod;
        this.traffic = null;
        await this.service.render();

        const { code, data } = await wiz.call("loadNetwork", { ...item, tr: tr });
        if (code != 200) return await this.service.alert.error("Error!");

        if (data) {
            for (let i = 0; i < data._time.length; i++)
                data._time[i] = (moment(data._time[i]).add(9, 'hours')).format("YYYY-MM-DD HH:mm:ss");

            this.traffic = {
                category: data._time,
                series: [{
                    name: 'IN',
                    data: data._in
                }, {
                    name: 'OUT',
                    data: data._out
                }]
            };
        }

        this.selectedNetwork = item;
        this.selectedNetwork.tr = tr;
        await this.service.render();
    }
}

export default PortalInstituteUserInfoComponent;